import React, { Suspense, useCallback, useContext, useState, lazy } from 'react';
import { Switch, Route, Redirect, HashRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import history from './history';
import { commonModules } from '../common/index';
import componentsModules from '../components/index';
import { routes } from './menu_routes';
import { setValue } from '../common/data_storage';


const Menu = lazy(() => import('../components/onboarding/Menu'));

const { UserContext, getCookie, getValue, circularProgress, storeContext, useTranslateText, Toast/* , useWindowDimensions */ } = commonModules,
      { Login, AppPage, Login_Customer, AppHeader, Sidebar, Footer, DashBoard } = componentsModules;

const create_dashboard_route = async (navFunctionData, mod_menu_routes) => {
  routes.map(item => {
    const isMod = mod_menu_routes?.find(el => el.key?.trim()?.toUpperCase() === item.key?.trim()?.toUpperCase());
    const searchKey = navFunctionData && navFunctionData.find(el => el.navMode?.trim()?.toUpperCase() === item.onboardingKey?.trim()?.toUpperCase()
      && item.beforeDashboard);
    if (isMod) {
      item.component = isMod.component;
    }
    if (searchKey || item.key === 'eelanguage' || item.key === 'eepassword') {
      item.beforeDashboard = false;
    }
    else {
      return;
    }
  });
  return routes;
};

const create_onboarding_route = async (onBoardingMenu, mod_menu_routes) => {
  routes.map(item => {
    const searchKey = onBoardingMenu && onBoardingMenu.find(el => el.navMode?.trim()?.toUpperCase() === item.onboardingKey?.trim()?.toUpperCase());
    const isMod = !isEmpty(mod_menu_routes) && mod_menu_routes.find(el => el.key?.trim()?.toUpperCase() === item.key?.trim()?.toUpperCase());
    if (isMod) {
      item.component = isMod.component;
    }
    if ((searchKey && item.key !== 'mfa_header') || item.key === 'eelanguage' || item.key === 'eepassword') {
      item.beforeDashboard = true;
    }
    else {
      return;
    }
  });
  return routes;
};


const Router = (props) => {
  const context = useContext(UserContext),
        [state, setState] = useState({
          LangCode: getValue('LangCode') || 'EN',
          refreshDashboard: getValue('refreshDashboard') || true,
          // isOnboardPage: getValue('isOnboardPage') || false,
          // logoImageUrl: getValue('logoImageUrl') || false,
          //selectedTask: getValue('selectedTask') || 1,
        }),
        // {width} = useWindowDimensions(),
        { state: storeState, dispatch } = useContext(storeContext),
        [publicIp, setPublicIp] = useState(),
        [menu, setMenu] = useState(getValue('Menu') || 'Dashboard'),
        [userLoginData, setUserLoginData] = useState(getValue('userLoginData') || {}),
        [show, setShow] = useState({
          open: false,
          vertical: 'top',
          horizontal: 'center',
        }),
        //[pageSelectedTask, setPageSelectedTask] = useState(getValue('selectedTask') || 1),

        setGlobalData = useCallback(async (StateName, Fields) => {
          setState(prevState => ({
            ...prevState,
            [StateName]: Fields,
          }));
        }, []),
        setLanguageCode = useCallback(async (Fields) => {
          setState(prevState => ({
            ...prevState,
            'LangCode': Fields,
          }));
        }, []),
        setIsOnboardPage = useCallback(async (Fields) => {
          setState(prevState => ({
            ...prevState,
            'isOnboardPage': Fields,
          }));
        }, []),
        setSelectedTaskData = useCallback(async (Fields) => {
          setState(prevState => ({
            ...prevState,
            'selectedTask': Fields,
          }));
        }, []),
        setRefereshDashboard = useCallback(async (Fields) => {
          setState(prevState => ({
            ...prevState,
            'refreshDashboard': Fields,
          }));
        }, []),
        setUserData = useCallback(async (stateName, Fields) => {
          setUserLoginData(prevState => ({
            ...prevState,
            [stateName]: Fields,
          }));
          setValue('userLoginData', {
            ...getValue('userLoginData'),
            [stateName]: Fields,
          });
        }, []),
        handleOpen = () => {
          setShow((prevState) => ({
            ...prevState,
            open: true,
          }));
        },

        handleClose = (_event, reason) => {

          if (reason === 'clickaway') {
            return;
          }

          setShow((prevState) => ({
            ...prevState,
            open: false,
          }));
        },
        { translateText } = useTranslateText(),
        { cookies } = props || {},
        { location: { pathname = false } = false } = window;

  context.isLogin = getCookie(cookies, 'is_login') || false;
  context.isOnboarding = getCookie(cookies, 'is_Onboarding') || false;
  //context.selectedTask = getCookie(cookies, 'SelectedTask') || 1;
  context.isOnboardPage = state.isOnboardPage;
  context.cookies = getCookie(cookies, 'stored_login_values');
  context.state = (!isEmpty(userLoginData) && userLoginData) || getValue('userLoginData') || {};
  context.setUserLoginData = setUserLoginData;
  context.setUserData = setUserData;
  context.custnum = (window?.location?.pathname !== '/' && window?.location?.pathname.replaceAll('/', '')) || getCookie(cookies, 'custnum');
  context.empid = getCookie(cookies, 'empid');
  context.kidb = getCookie(cookies, 'kidb') || '';
  context.kida = getCookie(cookies, 'kida') || '';
  context.mfaCookieID = getCookie(cookies, `mfaCookieID_${context.custnum}_${context.empid}`) || '';
  context.eida = getCookie(cookies, `eida_${context.mfaCookieID}`) || '';
  context.eidb = getCookie(cookies, `eidb_${context.mfaCookieID}`) || '';
  context.LangCode = state.LangCode;
  context.setLanguageCode = setLanguageCode;
  context.logoImageUrl = storeState?.logoImageUrl;
  context.setGlobalData = setGlobalData;
  context.setIsOnboardPage = setIsOnboardPage;
  context.history = history;
  context.menu_routes = routes;
  context.refreshDashboard = state.refreshDashboard;
  context.setRefereshDashboard = setRefereshDashboard;
  context.publicIp = publicIp || getCookie(cookies, 'remote_addr');
  context.setPublicIp = setPublicIp;
  // context.selectedTask = state.selectedTask || 1;
  context.setSelectedTaskData = setSelectedTaskData;
  context.Menu = menu || getValue('Menu');
  context.setMenu = setMenu;
  context.urlCustNum = storeState?.urlCustNum || (pathname !== '/' && pathname.replaceAll('/', ''));
  context.translateText = translateText;
  context.dispatch = dispatch;
  context.storeStateContext = storeState;
  context.handleOpen = handleOpen;
  context.handleClose = handleClose;

  const { isLogin, isOnboarding, isOnboardPage } = context,
        routeToComponent = () => {
          let value = 'dashboard';
          if (isLogin !== 'true') {
            value = 'login';
          }
          const Map = {
            'dashboard': <DashBoard />,
            'login': ((pathname === '/' && <Login />) || (<Login_Customer />)),
          };
          const RouteValue = Map[value].type;
          return RouteValue;
        };

  if (isLogin === 'true') {
    const { state: { NavFunctions: { navFunctionData = false }, mod_menu_routes } } = context || {};
    navFunctionData && create_dashboard_route(navFunctionData, mod_menu_routes)
      .then((route) => { context.menu_routes = route });
  }
  else if (isOnboarding === 'true') {
    const { state: { mod_menu_routes } } = context || {};
    if (context.state && context.state.Onboard_EE_Task) {
      create_onboarding_route(context.state.Onboard_EE_Task, mod_menu_routes).then((route) => {
        context.menu_routes = route;
        { /**to task seqence in onboarding menu and footer */ }
        context.selectedTask = getValue('selectedTask') || 1;
        context.setSelectedTask(context.selectedTask);
      });
    }
  }

  return (
    <div>
      <div className="content">
        {/**to show the alternative loading div before all the components loads */}
        <Suspense fallback={<div className="mt-3">{circularProgress}</div>}>
          <HashRouter>
              <AppPage>
                {(isLogin === 'true') && <><Suspense fallback={circularProgress}>
                  <AppHeader onclick={props.logOut}
                    {...context}> {/*handling logout of appheader sending props   */}
                  </AppHeader>
                </Suspense>
                <Suspense fallback={circularProgress}>
                  <Sidebar {...context} />
                </Suspense></>
                }
                {
                  isOnboarding === 'true' && isOnboardPage && <Suspense fallback={circularProgress}>
                    <Menu {...{ ...userLoginData }} />
                  </Suspense>
                }
                {
                  <Toast {...{ show, handleClose }} />
                }
                <Suspense fallback={circularProgress}>
                  <Switch>
                    <Route
                      exact
                      path="/"
                      render={() => {
                        return (
                          isLogin === 'true' ?
                            <Redirect to={routes[2].basePath} /> :
                            <Redirect to={pathname === '/' ? routes[0].basePath : routes[1].basePath} />
                        );
                      }}
                    />

                    <Route exact path={`${isLogin === 'true' ? routes[2].basePath : (pathname === '/' && routes[0].basePath) || (routes[1].basePath)}`}
                      component={routeToComponent()} />
                    {
                      routes.map((item) => {
                        const { basePath, component, params, key, beforeDashboard, isDone } = item;
                        if (isLogin === 'true' && component in componentsModules && !beforeDashboard && isDone)
                          return <Route key={key} path={`${basePath}${params}`} component={componentsModules[component]} />;
                        else if (isLogin !== 'true' && component in componentsModules && beforeDashboard && isDone)
                          return <Route key={key} path={`${basePath}${params}`} component={componentsModules[component]} />;
                      })
                    }
                    <Route path="*">
                      <NoMatch {...{ isLogin, isOnboarding, pathname }} />
                    </Route>
                  </Switch>
                </Suspense>
                <Suspense fallback={circularProgress}>
                  {window.location.href.indexOf('login') === -1 && <Footer {...{ isOnboardPage }} />}
                </Suspense>
              </AppPage>
          </HashRouter>
        </Suspense>
      </div>
    </div>
  );
};

export default Router;

Router.propTypes = {
  state: PropTypes.object,
  logOut: PropTypes.func,
  routePath: PropTypes.string,
};

const NoMatch = (props) => {
  const { isLogin, pathname } = props;

  return (
    isLogin === 'true' ?
      <Redirect to={routes[2].basePath} /> :
      <Redirect to={pathname === '/' ? routes[0].basePath : routes[1].basePath} />
  );
};
